import { drama } from '../constants/actionTypes';
import {
  REQUEST_STATE_READY,
  REQUEST_STATE_REQUESTING,
  REQUEST_STATE_FAILED,
  REQUEST_STATE_SUCCEEDED,
} from '../../constants/state';

export const initialState = {
  summary: [],
  summaryFetchState: REQUEST_STATE_READY,
  categories: [],
};

export default (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    case drama.FETCH_DRAMA_SUMMARY:
      return {
        ...state,
        summaryFetchState: REQUEST_STATE_REQUESTING,
      };

    case drama.FETCH_DRAMA_SUMMARY_SUCCESS:
      return {
        ...state,
        summary: payload.result,
        summaryFetchState: REQUEST_STATE_SUCCEEDED,
      };

    case drama.FETCH_DRAMA_SUMMARY_FAILED:
      return {
        ...state,
        summaryFetchState: REQUEST_STATE_FAILED,
      };

    case drama.FETCH_DRAMA_CATEGORY_SUCCESS:
      return {
        ...state,
        categories: payload?.normalizedData ? payload.normalizedData.result : state.categories,
      };

    default:
      return state;
  }
};
